import React, { useEffect, useState } from "react";
// Magic components
import MagicDrawer from "../components/common/MagicDrawer_new";

// @mui
import Stack from "../components/mui/Stack";
// @mui components:
import Button from "../components/mui/Button";

import ImageComponent from "../components/mui/Image";

import ReportFilterForm, {
  CityType,
  FilterStateType,
} from "../components/Report/ReportFilterForm";
import Tabs from "../components/targetAchivment/Tabs";
import SelectedTable from "../components/Report/SelectedTable ";
import SummaryReportContainer from "./SummaryReport";

// APIs
import {
  useCenterListQuery,
  useFetchedFunderQuery,
  useFetchedProgramTypesQuery,
  useFetchRegionQuery,
  useUserListQuery,
} from "../store/apis/centerApis";
import { useFetchManageAwardQuery } from "../store/apis/reportsApis";
import { State, City } from "country-state-city";
import { useSelector } from "react-redux";
import { RootState } from "../../src/store";
import usePermission from "../helper/usePermission";
import { acl } from "../helper/userAccessConstant";

interface TabCategory {
  id: number;
  name: string;
  code: string;
}
interface IndianCity {
  label: string;
  id: string;
}

type Cities = IndianCity[];

const dummyTabCategories: TabCategory[] = [
  { id: 1, name: "Parameter wise", code: "PARAMETER_WISE" },
  { id: 2, name: "Medal wise", code: "MEDAL_WISE" },
  { id: 3, name: "Score wise", code: "SCORE_WISE" },
  { id: 4, name: "Target VS Achievement", code: "TARGET_VS_ACHIEVEMENT" },
  { id: 5, name: "Attendance", code: "ATTENDANCE" },
  { id: 6, name: "Summary report", code: "SUMMARY_REPORT" },
];

const ReportsContainer: React.FC = () => {
  const initialFilterState: FilterStateType = {
    regions: [],
    selectedRegion: [],
    center: null,
    programPerformanceParameter: null,
    qualityEfficacyParameter: null,
    state: null,
    city: null,
    funder: null,
    regionalDataManager: null,
    cityManager: null,
    clusterManager: null,
    medals: null,
    programMasterId: null,
    ProgramYearId: null,
    quarterMasterId: null,
  };
  const { permissions } = usePermission();

  // Get configuration permissions
  const reportAccess = permissions[acl.reports.module];

  const reportAvailableTab: TabCategory[] = [
    reportAccess?.parameter_wise && {
      id: 1,
      name: "Parameter wise",
      code: "PARAMETER_WISE",
    },
    reportAccess?.medal_wise && {
      id: 2,
      name: "Medal wise",
      code: "MEDAL_WISE",
    },
    reportAccess?.score_wise && {
      id: 3,
      name: "Score wise",
      code: "SCORE_WISE",
    },
    reportAccess?.target_vs_achievement && {
      id: 4,
      name: "Target VS Achievement",
      code: "TARGET_VS_ACHIEVEMENT",
    },
    reportAccess?.attendance && {
      id: 5,
      name: "Attendance",
      code: "ATTENDANCE",
    },
    reportAccess?.summary_report && {
      id: 6,
      name: "Summary report",
      code: "SUMMARY_REPORT",
    },
  ].filter(Boolean) as TabCategory[];

  const filterData = useSelector((state: RootState) => state?.user?.filter); // Fetching master filter from Redux state:
  const defaultTab =
    reportAvailableTab?.find(
      (tab) => tab?.code === reportAvailableTab[0]?.code
    ) || null;
  const [isOpenFilterForm, setIsOpenFilterForm] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<TabCategory | null>(
    defaultTab
  );
  const [filter, setFilter] = useState<any>({ ...initialFilterState });
  const [isLessThen3Value, setIsLessThen3Value] = useState<boolean>(false);
  const [params, setParams] = useState<{
    [key: string]: number | string | undefined;
  }>({
    pageNo: "1",
    pageSize: "10",
    programMasterId: filterData?.selectedProgram?.value || undefined,
    quarterMasterId: filterData?.selectedQuarter?.quarterMasterId || undefined,
    ProgramYearId: filterData?.selectedYear?.value || undefined,
  });
  const [cities, setCities] = useState<Cities>([]);
  useEffect(() => {
    const paramObj: { [key: string]: number | string | undefined } = {
      programMasterId: filterData?.selectedProgram?.value,
      ProgramYearId: filterData?.selectedYear?.value,
    };
    if (filterData?.selectedQuarter?.quarterMasterId) {
      paramObj.quarterMasterId = filterData.selectedQuarter.quarterMasterId;
    }
    setParams(paramObj);
  }, [filterData]);
  const handlePagination = (pageNo: number) => {
    setParams((prev) => ({ ...prev, pageNo }));
  };

  const handleReportSearch = (value: string | number) => {
    const searchValue = typeof value === "number" ? value.toString() : value;
    const isLessThan3 = searchValue.length > 0 && searchValue.length < 3;
    setIsLessThen3Value(isLessThan3);
    if (searchValue.length >= 3) {
      setParams((prev) => ({ ...prev, pageNo: 1, search: searchValue }));
    } else if (searchValue.length === 0) {
      setParams({
        pageNo: "1",
        pageSize: "10",
        programMasterId: filterData?.selectedProgram?.value || undefined,
        quarterMasterId:
          filterData?.selectedQuarter?.quarterMasterId || undefined,
        ProgramYearId: filterData?.selectedYear?.value || undefined,
        search: undefined,
      });
    }
  };

  const toggleFilterFormDrawer = () => {
    setIsOpenFilterForm((prev) => !prev);
  };

  const handleCategoryChange = (id: number) => {
    const selectedCategory = reportAvailableTab?.find(
      (category) => category.id === id
    );
    if (selectedCategory) {
      setSelectedTab(selectedCategory);
      setFilter({ ...initialFilterState });
      setParams({
        pageNo: "1",
        pageSize: "10",
        programMasterId: filterData?.selectedProgram?.value || undefined,
        quarterMasterId:
          filterData?.selectedQuarter?.quarterMasterId || undefined,
        ProgramYearId: filterData?.selectedYear?.value || undefined,
        search: undefined,
      });
    } else {
      console.log("Category not found for ID:", id);
    }
  };

  const handleClearAllFilterBtn = () => {
    setFilter({ ...initialFilterState });
    setParams({
      programMasterId: filterData?.selectedProgram?.value || undefined,
      quarterMasterId:
        filterData?.selectedQuarter?.quarterMasterId || undefined,
      ProgramYearId: filterData?.selectedYear?.value || undefined,
      pageNo: "1",
      pageSize: "10",
      search: undefined,
    });
  };

  const magicPageHeaderBtn = [
    {
      text: "Download",
      variant: "outlined",
      startIcon: (
        <ImageComponent
          src="/assets/images/login/exportIcon.svg"
          alt="ExportIcon"
        />
      ),
      sx: {
        background: "white",
        border: "1px solid #D0D5DD",
        borderRadius: "8px",
        color: "black",
      },
    },
  ];

  const magicTableHeaderBtn = [
    {
      text: "Add Filters",
      variant: "outlined",
      startIcon: (
        <ImageComponent
          src="/assets/images/login/addFilterIcon.svg"
          alt="AddFilterIcon"
        />
      ),
      onClick: toggleFilterFormDrawer,
      sx: {
        background: "white",
        border: "1px solid #D0D5DD",
        borderRadius: "8px",
        color: "black",
      },
    },
  ];

  const preparePayload = (filter: FilterStateType) => {
    const {
      regions,
      selectedRegion,
      center,
      programPerformanceParameter,
      qualityEfficacyParameter,
      state,
      city,
      funder,
      regionalDataManager,
      cityManager,
      clusterManager,
      medals,
    } = filter;
    const parseRegion = (regions: any) =>
      regions.map((r: any) => r.id).join(",");
    const payload: any = {
      pageNo: "1",
      pageSize: "10",
      regions: regions.length > 0 ? regions.join(",") : undefined,
      region: parseRegion(selectedRegion) || undefined,
      center: center?.id,
      programPerformanceParameter: programPerformanceParameter?.id,
      qualityEfficacyParameter: qualityEfficacyParameter?.id,
      state: state?.label,
      district: city?.label,
      funder: funder?.id,
      regionalDataManagerUserId: regionalDataManager?.id,
      cityManagerUserId: cityManager?.id,
      clusterManagerUserId: clusterManager?.id,
      programMasterId: filterData?.selectedProgram?.value || undefined,
      quarterMasterId:
        filterData?.selectedQuarter?.quarterMasterId || undefined,
      ProgramYearId: filterData?.selectedYear?.value || undefined,
      medals: medals?.id,
    };

    return payload;
  };
  const handleApplyFilterBtn = () => {
    try {
      setParams(preparePayload(filter));
      setIsOpenFilterForm((prevState) => !prevState);
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleFilterFormChange = (field: string, value: any) => {
    if (field === "state") {
      const indianCities: IndianCity[] = value?.id
        ? City.getCitiesOfState("IN", value?.id).map((city) => ({
            label: city.name,
            id: city.name,
          }))
        : [];
      setCities(indianCities);
    }
    setFilter((prevFilter:any) => ({
      ...prevFilter,
      [field]: value,
    }));
  };

  // APIs calling
  const { data: centerList = {} , refetch : centerListRefetch } = useCenterListQuery({
    state: filter.state ? filter?.state?.label : undefined,
    district: filter.city ? filter?.city?.label : undefined,
    region: filter.region ? filter?.region : undefined,
    pageNo: "1",
    pageSize:"10000"
  },
  { refetchOnMountOrArgChange: true }
);
  const { data: cityManager = [] } = useUserListQuery({ roleId: "4" });
  const { data: clusterManager = [] } = useUserListQuery({ roleId: "5" });
  const { data: regionalDataManager = [] } = useUserListQuery({ roleId: "9" });
  const { data: fetchedRegion = [] } = useFetchRegionQuery();
  const { data: fetchedFunder = [] } = useFetchedFunderQuery();
  const indianStates: { label: string; id: string }[] =
    State.getStatesOfCountry("IN")?.map((state) => ({
      label: state.name,
      id: state.isoCode,
    })) || [];

  const { data } = useFetchManageAwardQuery();
  const {
    data: fetchedProgramTypes = { programTypes: [], programSubTypes: [] },
  } = useFetchedProgramTypesQuery()  

  return (
    <Stack>
      <Tabs tabs={reportAvailableTab} handleTabChange={handleCategoryChange} />
      {selectedTab?.code === "SUMMARY_REPORT" ? (
        <SummaryReportContainer />
      ) : (
        <SelectedTable
          selectedTab={selectedTab}
          params={params}
          isInvalidSearch={isLessThen3Value}
          onPaginationChange={handlePagination}
          onSearch={handleReportSearch}
          magicPageHeaderBtn={magicPageHeaderBtn}
          magicTableHeaderBtn={magicTableHeaderBtn}
        />
      )}
      <MagicDrawer
        title="Add Filters"
        subtitle="See the data in an organized manner by applying filters"
        drawerOpen={isOpenFilterForm}
        onDrawerToggle={toggleFilterFormDrawer}
        actionComponent={() => (
          <>
            <Button className="bun-outline" onClick={handleClearAllFilterBtn}>
              Clear All
            </Button>
            <Button className="bun-filled" onClick={handleApplyFilterBtn}>
              Apply
            </Button>
          </>
        )}
      >
        <ReportFilterForm
          selectedTab={selectedTab}
          regions={fetchedRegion}
          centerList={centerList}
          programParameters={fetchedProgramTypes.programTypes}
          qualityParameters={fetchedProgramTypes.programSubTypes}
          states={indianStates}
          city={cities}
          cityManagers={cityManager}
          clusterManagers={clusterManager}
          funders={fetchedFunder}
          regionalDataManagers={regionalDataManager}
          medals={data}
          filter={filter}
          handleFilterFormChange={handleFilterFormChange}
        />
      </MagicDrawer>
    </Stack>
  );
};

export default ReportsContainer;
